/*
  HILO - keeps Custom - Collection SEO in step with the circles.
  Loaded by sections/hilo-collection-seo.liquid.

  Tapping a circle or a style in Custom - Collection grid swaps the products
  in place and moves the address to /collections/<handle> without reloading
  the page. The SEO copy and FAQ at the bottom, and the title in the browser
  tab, were rendered for the collection the shopper landed on, so they stayed
  on that collection whichever circle was picked.

  Whenever the address moves to a different collection, this asks Shopify for
  that collection's own Collection SEO block (Section Rendering API), puts it
  in place and sets the tab title to match. A collection with no SEO copy
  shows none - the same as its own page when opened directly. Each collection
  is fetched once per visit and then reused.

  Filters, sort, the Sale pill and infinite scroll stay on the same
  collection, so they never fetch anything here.
*/
(function () {
  if (window.hiloCseoSync) return;
  window.hiloCseoSync = true;
  if (!window.fetch || !window.DOMParser || !window.history || !history.pushState) return;

  var PREFIX = 'shopify-section-';
  var cache = {};
  var applied = handleOf(location.pathname);
  var wanted = applied;
  var token = 0;

  /* /collections/kurtas/hand-painted -> kurtas */
  function handleOf(path) {
    path = path || '';
    var i = path.indexOf('/collections/');
    if (i < 0) return '';
    return path.slice(i + 13).split('/')[0].toLowerCase();
  }

  function has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  }

  function titleIn(root) {
    var t = root && root.querySelector('template[data-hilo-doctitle]');
    var s = t ? (t.content ? t.content.textContent : t.textContent) : '';
    return (s || '').trim();
  }

  /* One collection's block as { html, title }, or null when the reply has
     none. `id` is the section id asked for; `pageId` is the id of the block
     on this page. */
  function get(handle, id, pageId) {
    return fetch('/collections/' + handle + '?sections=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (txt) {
        var html = txt;
        try {
          var json = JSON.parse(txt);
          if (typeof json[id] !== 'string') return null;
          html = json[id];
        } catch (e) {
          /* Not JSON: a redirect dropped ?sections= and the whole page came
             back. The block is read out of that instead. */
        }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var w = doc.getElementById(PREFIX + id) || doc.querySelector('.hilo-cseo-section');
        if (!w) return null;
        var inner = w.innerHTML;
        /* The block's styles are scoped to its wrapper's id. Rendered under
           another id, they are pointed at the wrapper on this page. */
        if (w.id && w.id !== PREFIX + pageId) inner = inner.split(w.id).join(PREFIX + pageId);
        return { html: inner, title: titleIn(w) };
      });
  }

  function load(handle, pageId) {
    if (has(cache, handle)) return Promise.resolve(cache[handle]);
    return get(handle, pageId, pageId)
      .then(function (res) {
        /* Not found under this page's id: render the section file itself. */
        return res || get(handle, 'hilo-collection-seo', pageId);
      })
      .then(function (res) {
        res = res || { html: '', title: '' };
        cache[handle] = res;
        return res;
      });
  }

  function sync() {
    var handle = handleOf(location.pathname);
    if (!handle || handle === wanted) return;
    var w = document.querySelector('.hilo-cseo-section');
    if (!w || w.id.indexOf(PREFIX) !== 0) return;
    var pageId = w.id.slice(PREFIX.length);
    if (applied && !has(cache, applied)) {
      cache[applied] = { html: w.innerHTML, title: titleIn(w) || document.title };
    }
    wanted = handle;
    var mine = ++token;
    load(handle, pageId).then(function (res) {
      if (mine !== token) return;
      w.innerHTML = res.html;
      applied = handle;
      if (res.title) document.title = res.title;
    }, function () {
      if (mine !== token) return;
      /* Never leave another collection's copy under this address. */
      w.innerHTML = '';
      applied = '';
      wanted = '';
    });
  }

  function hook(name) {
    var orig = history[name];
    if (typeof orig !== 'function') return;
    history[name] = function () {
      var out = orig.apply(history, arguments);
      try { sync(); } catch (e) {}
      return out;
    };
  }

  hook('pushState');
  hook('replaceState');
  window.addEventListener('popstate', function () {
    try { sync(); } catch (e) {}
  });
})();
